
import HeadersManager from '../rest/HeadersManager'
import { getUuid } from './uuid'

const uuid = getUuid()

export const getNativeHeaders = (forceChange?: boolean) => {
  const headers: Record<string, unknown> = {
    xClientHash: uuid,
    token: HeadersManager.jwt.get(),
    wssId: HeadersManager.connectionId.get(),
    xDatabase: process.env.REACT_APP_DB_HEADER,
  }

  if (typeof forceChange === 'boolean') {
    headers.forceChange = forceChange
  }

  return JSON.stringify(headers)
}